function cov_a4lt1zzpl() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ProgressBar.tsx";
  var hash = "23d5f6e3dbbf3f874126df9404075ab8d1f85748";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ProgressBar.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "23d5f6e3dbbf3f874126df9404075ab8d1f85748"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_a4lt1zzpl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_a4lt1zzpl();
var Icon = (cov_a4lt1zzpl().s[0]++, {
  name: 'progress-bar',
  svg: "<rect y=\"5\" width=\"12\" height=\"2\" rx=\"1\" fill=\"currentColor\" />\n  <rect y=\"5\" width=\"8\" height=\"2\" rx=\"1\" fill=\"currentColor\" />"
});
export default Icon;